// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__krgvW","iconStyle":"Header_iconStyle__3FcWc","dynamicHeaderRight":"Header_dynamicHeaderRight__22Fbv","rightWrapper":"Header_rightWrapper__3uirr"};